import { FunctionComponent, useState } from 'react'
import { MdPlayArrow, MdRefresh } from 'react-icons/md'

import { steps } from '../..'
import iconEmail from 'shared/assets/icons/icon-email.png'
import Page from 'shared/components/Page'
import Text from 'shared/components/Text'
import Button from 'shared/components/Button'
import { SingleInputBoxes } from 'shared/components/InputBox/SingleInputBoxes'
import { colors } from 'shared/styles/colors'

import { IEmailProps } from './EmailComponent.types'
import { Container } from '../Email/styles'
import {
  ContainerDescription,
  TextButton,
  ContainerInputs,
  StyledError,
  ResendButton,
} from './styles'

const EmailConfirm: FunctionComponent<IEmailProps> = ({
  validateEmailByCode,
  setSelectedStep,
  validateEmail,
}) => {
  const email = localStorage.getItem('@TMov:ChangeGestorEmail')
  const [loadingResend, setLoadingResend] = useState(false)
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const handleReSendCodeEmail = async () => {
    setLoadingResend(true)
    setErrorMessage('')

    try {
      await validateEmail.execute(email)

      setLoadingResend(false)
    } catch (e: any) {
      setLoadingResend(false)

      setErrorMessage(e.message)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)
    setErrorMessage('')
    try {
      await validateEmailByCode.execute(email, code)
      setSelectedStep(steps.Phone)
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Erro ao validar email por código')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (p_code: string) => {
    setErrorMessage('')
    setCode(p_code)
  }

  return (
    <Page
      title="Confirme seu endereço de e-mail"
      icon={iconEmail}
      goBackTo={() => {
        setSelectedStep(steps.Email)
      }}
    >
      <Container>
        <ContainerDescription>
          <Text color={colors.white}>
            Informe o código de verificação que enviamos para
          </Text>
          <Text color={colors.white} style={{ paddingBottom: 12 }}>
            {`${email} `}
            <TextButton onClick={() => setSelectedStep(steps.Email)}>
              (Alterar)
            </TextButton>
          </Text>
          <Text color={colors.white}>
            Caso não consiga encontrá-lo, verifique sua caixa de spam.
          </Text>
        </ContainerDescription>
        <ContainerInputs>
          <SingleInputBoxes
            type="text"
            amount={6}
            onChangeValueInputBox={handleChange}
          />
          {errorMessage && <StyledError>{errorMessage}</StyledError>}
        </ContainerInputs>

        <ResendButton
          transparent={true}
          color={colors.grayLight}
          disabled={loadingResend}
          loading={loadingResend}
          type="button"
          onClick={handleReSendCodeEmail}
        >
          <MdRefresh /> REENVIAR CÓDIGO
        </ResendButton>
        <Button
          color={colors.green}
          disabled={code.length !== 6}
          loading={loading}
          onClick={handleSubmit}
        >
          <MdPlayArrow /> Próximo
        </Button>
      </Container>
    </Page>
  )
}

export default EmailConfirm
